import React from 'react';
import styled from 'styled-components';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import Button from '../common/Button';
import QuickInquiryForm from '../forms/QuickInquiryForm';

const ContactSection = styled.section`
  background-color: ${props => props.theme.colors.white};
  padding: 80px 0;
`;

const ContactContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 50px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const ContactContent = styled.div`
  flex: 1;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    text-align: center;
  }
`;

const ContactTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const ContactDescription = styled.p`
  margin-bottom: 30px;
  color: ${props => props.theme.colors.grey[600]};
  font-size: ${props => props.theme.fontSizes.regular};
  line-height: 1.8;
`;

const ContactInfo = styled.div`
  margin-bottom: 30px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    justify-content: center;
  }
  
  svg {
    color: ${props => props.theme.colors.primaryColor};
    font-size: 1.2rem;
    margin-right: 15px;
  }
  
  p {
    color: ${props => props.theme.colors.grey[700]};
  }
`;

const FormContainer = styled.div`
  flex: 1;
`;

const ContactPreview = () => {
  return (
    <ContactSection>
      <div className="container">
        <ContactContainer>
          <ContactContent>
            <ContactTitle>Get in Touch</ContactTitle>
            <ContactDescription>
              Have questions about our programs or want to enroll? Contact us today!
            </ContactDescription>
            
            <ContactInfo>
              <ContactItem>
                <FaEnvelope />
                <p>kalsacademy1@gmail.com</p>
              </ContactItem>
              <ContactItem>
                <FaPhone />
                <p>+91 9444108728</p>
              </ContactItem>
              <ContactItem>
                <FaMapMarkerAlt />
                <p>Chennai, Tamil Nadu, India</p>
              </ContactItem>
            </ContactInfo>
            
            <Button to="/contact" variant="primary">Contact Us</Button>
          </ContactContent>
          
          <FormContainer>
            <QuickInquiryForm />
          </FormContainer>
        </ContactContainer>
      </div>
    </ContactSection>
  );
};

export default ContactPreview;
